module.exports = __webpack_public_path__ + "static/media/container6.7e9ac8fb.jpg";